import { lazyLoad } from 'utils/loadable';

export const HomeTemplate = lazyLoad(
  () => import('./homeTemplate.page'),
  (module) => module.HomeTemplate
);
